import React, { createContext, useContext, useState } from "react";

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  // Load token from localStorage
  const [admin, setAdmin] = useState(() => {
    const token = localStorage.getItem("admin_token");
    return token ? { token } : null;
  });

  // Store token in state + localStorage
  const loginAdmin = (token) => {
    const adminData = { token };
    setAdmin(adminData);
    localStorage.setItem("admin_token", token); // ✔ store only the token
  };

  const logoutAdmin = () => {
    setAdmin(null);
    localStorage.removeItem("admin_token"); // ✔ remove token
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loginAdmin, logoutAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
